<div id="doctors-list" class="flex flex-col gap-3">
  <div class="flex flex-row justify-between">
    <a class="cursor-pointer flex flex-row" (click)="goBack()">
      <mat-icon>arrow_back</mat-icon>
      <p>Back</p>
    </a>
    <div class="flex flex-row gap-3">
      <button mat-flat-button color="primary" (click)="uploadPdf()">Upload PDF Report</button>
      <button mat-flat-button color="primary" (click)="createReport()">Add Report</button>
    </div>
  </div>
  @if (reports) {
  <nz-table #basicTable [nzData]="reports">
    <thead>
      <tr>
        <th>ID/Name</th>
        <th>Updated Date</th>
        <th>Action</th>
      </tr>
    </thead>
    <tbody>
      @for (data of basicTable.data; track data) {
      <tr>
        <td>{{ data.id }}</td>
        <td>{{ data.updated_at | date: 'MM/dd/yyyy HH:mm' }}</td>
        <td>
          <button nz-button nzType="primary" (click)="openReport(data)">
            <nz-icon nzType="eye" nzTheme="outline" />
          </button>
          <button nz-button nzType="primary" nzDanger nz-popconfirm
            nzPopconfirmTitle="Are you sure to delete this report?" (nzOnConfirm)="deleteReportAndReload(data.id)"
            (nzOnCancel)="cancel()">
            <nz-icon nzType="delete" />
          </button>
        </td>
      </tr>
      }
    </tbody>
  </nz-table>
  }
</div>

<nz-modal [(nzVisible)]="uploadPdfModalVisible" nzTitle="The first Modal">
  <ng-container *nzModalContent>
    <nz-upload nzType="drag" [nzAction]="urlToUpload" [nzHeaders]="{ authorization: 'authorization-text' }"
      (nzChange)="handleChange($event)">
      <p class="ant-upload-drag-icon">
        <nz-icon nzType="inbox" />
      </p>
      <p class="ant-upload-text">Click or drag file to this area to upload</p>
      <p class="ant-upload-hint">
        Support for a single or bulk upload. Strictly prohibit from uploading company data or other band files
      </p>
    </nz-upload>
  </ng-container>
  <div *nzModalFooter>
    <button nz-button nzType="primary" (click)="handleCancel()" [nzLoading]="isUploading">Close</button>
  </div>
</nz-modal>